export enum EnumUTAMasterPasswordFormField {
  password = 'password',
  confirmPassword = 'confirmPassword',
  pinCode = 'pin',
}

export enum EnumUTAInvestorPasswordFormField {
  password = 'password',
  confirmPassword = 'confirmPassword',
  pinCode = 'pin',
}

export enum EnumUTALeverageFormField {
  leverage = 'leverage',
}
